// contained feature card
$(window).on('load resize', function() {

    $('.card-feature-contained .card-body-text').each(function() {
        $this = $(this);
        elementHeight = $this.outerHeight();

        $this
        .css({
            "height": elementHeight,
            "margin-bottom": -elementHeight
        });
    });

}).resize();
